import { z } from '#node_modules/zod';
import { parseWithZod } from '@conform-to/zod';
import { useFetchers } from '@remix-run/react';
import { DEFAULT_THEME } from '#app/constants.ts';
import { useHints } from '#app/utils/client-hints.tsx';
import { useRequestInfo } from '#app/utils/request-info.ts';

export const ThemeFormSchema = z.object({
  theme: z.enum(['system', 'light', 'dark']),
});

/**w
 * If the user's changing their theme mode preference, this will return the
 * value it's being changed to.
 */
export function useOptimisticThemeMode() {
  const fetchers = useFetchers();
  const themeFetcher = fetchers.find((f) => f.formAction === '/');

  if (themeFetcher && themeFetcher.formData) {
    const submission = parseWithZod(themeFetcher.formData, {
      schema: ThemeFormSchema,
    });

    if (submission.status === 'success') {
      return submission.value.theme;
    }
  }
}

/**
 * @returns the user's theme preference, or the client hint theme if the user
 * has not set a preference.
 */
export function useOptimisticTheme(withHints = false) {
  const hints = useHints();
  const requestInfo = useRequestInfo();
  const optimisticMode = useOptimisticThemeMode();
  if (optimisticMode) {
    return { theme: optimisticMode, requestInfo };
  }

  let theme = requestInfo.userPrefs.theme;
  if (theme == null) {
    theme = withHints ? hints.theme : DEFAULT_THEME;
  }

  return { theme, requestInfo };
}
